import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
} from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import SearchBar from './SearchBar';
import LanguageSelector from './LanguageSelector';
import CategoryButtons from './CategoryButtons';
import logo from '../assets/images/logo.png';
import burgerIcon from '../assets/images/burger-icon.svg';

const ToolbarContent = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  margin: '0 auto',
  boxSizing: 'border-box'
}));

function Header({ 
  isMobile, 
  language, 
  country, 
  countryOptions,
  onLanguageChange, 
  onCountryChange, 
  onDrawerToggle,
  onSelectedStoreChange,
  categories,
  selectedCategory,
  onCategorySelect,
  selectedStore
}) {
  return (
    <AppBar position="sticky" color="primary" elevation={0}>
      <Toolbar 
        sx={{ 
          p: 0,
          boxSizing: 'border-box'
        }}
      >
        <Box sx={{ 
          width: '100%',
          px: isMobile ? 2 : 6,
          py: isMobile ? 1 : 4,
        }}>
          <ToolbarContent>
            <img src={logo} alt="Logo" style={{ height: 100 }} /> 
            {!isMobile && (
              <>
                <SearchBar 
                  language={language} 
                  isMobile={isMobile} 
                  selectedStore={selectedStore} // Add this prop
                  onSelectedStoreChange={onSelectedStoreChange} 
                />
                <LanguageSelector
                  language={language}
                  country={country}
                  countryOptions={countryOptions}
                  onLanguageChange={onLanguageChange}
                  onCountryChange={onCountryChange}
                />
              </>
            )}

            {isMobile && (
              <IconButton color="inherit" onClick={onDrawerToggle}>
                <img 
                  src={burgerIcon}
                  alt="Menu Icon" 
                  style={{ height: 50, width: 50 }} 
                />
              </IconButton>
            )}
          </ToolbarContent>
        </Box>
      </Toolbar>
      {isMobile && (
        <Box sx={{ paddingBottom: isMobile ? 2 : 0 }}>
          <SearchBar 
            language={language} 
            isMobile={isMobile} 
            selectedStore={selectedStore} // Add this prop
            onSelectedStoreChange={onSelectedStoreChange}
          />
        </Box>
      )}
      <CategoryButtons 
        categories={categories}
        selectedCategory={selectedCategory}
        onCategorySelect={onCategorySelect}
      />
    </AppBar>
  );
}

export default Header;